module.exports = "/_next/static/images/OgStateOfPersonalizationReport2024-81ea6681015bbcbd56db0633e3fe2f9d.jpg";